import { useCallback, useEffect, useState } from 'react';
import { ownerOptions, ownerScope, type OwnerOption } from '@/lib/forex-owner-coordinator';
import { useProfitEnvironment } from './use-agent-profit';
import { useAdminAuth } from '@/hooks/useAdminAuth';
export function useOperatorOwnerOptions(enabled: boolean) {
  const environment = useProfitEnvironment();
  const { admin } = useAdminAuth();
  const scope = `${environment}:${admin?.id || ''}`;
  const [version, setVersion] = useState(0);
  const [state, setState] = useState<{scope: string; items: OwnerOption[]; loading: boolean; error: string}>({scope, items: [], loading: enabled, error: ''});
  const refresh = useCallback(() => setVersion(v => v + 1), []);
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setState(old => ({scope, items: old.scope === scope ? old.items : [], loading: true, error: ''}));
    void ownerOptions(controller.signal).then(items => {
      if (!controller.signal.aborted) setState({scope, items, loading: false, error: ''});
    }).catch(() => {
      if (!controller.signal.aborted) setState({scope, items: [], loading: false, error: '团队读取失败，可重试或暂不指定团队'});
    });
    return () => controller.abort();
  }, [enabled, scope, version]);
  useEffect(() => {
    if (!enabled) return;
    const changed = (detail: {environmentId?: string; actorId?: string}) => {
      const current = ownerScope();
      if (current && current.environmentId === detail.environmentId && current.actorId === detail.actorId) refresh();
    };
    const event = (e: Event) => changed((e as CustomEvent).detail || {});
    window.addEventListener('focus', refresh);
    window.addEventListener('forex-owner-catalog-changed', event);
    let channel: BroadcastChannel | undefined;
    try { channel = new BroadcastChannel('forex-owner-catalog'); channel.onmessage = e => changed(e.data); } catch { /* Manual refresh is always available. */ }
    return () => { window.removeEventListener('focus', refresh); window.removeEventListener('forex-owner-catalog-changed', event); channel?.close(); };
  }, [enabled, refresh]);
  return {...(state.scope === scope ? state : {scope, items: [], loading: enabled, error: ''}), refresh};
}
